// src/components/AppleNumberInput.tsx
import React from "react";
import clsx from "clsx";
import { AppleInput } from "./AppleInput";
import {
  selectAllOnFocus,
  handleMouseDownSelectAll,
} from "./inputBehaviors";

type AppleNumberInputProps = Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  "type"
> & {
  selectAllOnFirstClick?: boolean;
};

export function AppleNumberInput({
  className,
  onFocus,
  onMouseDown,
  inputMode = "decimal",
  selectAllOnFirstClick = true,
  ...props
}: AppleNumberInputProps) {
  function handleFocus(e: React.FocusEvent<HTMLInputElement>) {
    if (selectAllOnFirstClick) selectAllOnFocus(e);
    onFocus?.(e);
  }

  function handleMouseDown(e: React.MouseEvent<HTMLInputElement>) {
    if (selectAllOnFirstClick) handleMouseDownSelectAll(e);
    onMouseDown?.(e);
  }

  return (
    <AppleInput
      {...props}
      type="text"
      inputMode={inputMode}
      isNumber
      onFocus={handleFocus}
      onMouseDown={handleMouseDown}
      className={clsx(className)}
    />
  );
}